import { useAuth } from './useAuth';

/**
 * Returns whether commission dollar amounts should be hidden for the current user.
 * When true, components should show "—" or similar placeholder instead of dollar values.
 * Loan counts, dates, broker names, and non-financial metrics are still shown.
 */
export function useHideCommissions(): boolean {
  const { hideCommissions } = useAuth();
  return hideCommissions;
}

/**
 * Portfolio totals switch. Only meaningful alongside `useHideCommissions()`:
 * it keeps loan-VOLUME figures (loan book, loans settled) visible for a user
 * whose commission dollars are hidden. It never unhides a commission figure.
 */
export function useShowLoanTotals(): boolean {
  const { showLoanTotals } = useAuth();
  return showLoanTotals;
}

/**
 * Whether loan-VOLUME figures should be hidden for the current user: true only
 * when commissions are hidden AND the portfolio totals switch is off.
 *
 * Prefer this over hand-writing `hideCommissions && !showLoanTotals` at each
 * call site - a volume gate written with the wrong polarity shows commission
 * dollars to an account that must not see them.
 */
export function useHideLoanVolume(): boolean {
  const { hideCommissions, showLoanTotals } = useAuth();
  return hideCommissions && !showLoanTotals;
}
